<template>
  <div id="modal" class="modal modal-auto-height" role="dialog">
    <button
      type="button"
      class="btn-close"
      @click="close"
      aria-label="Close modal"
      title="Close"
    >
      ×
    </button>

    <header class="modal-header">
      <h3 class="modal-header-title">Appling for this Job listing</h3>
    </header>

    <section class="modal-body">
      <p>Click on the link below to be redirected to the organisation's website.</p>
      <button class="btn btn-bold btn-full btn-rounded btn-esc-red" @click="doApply" :disabled="isDisabled" :title="title">Apply on organisation's site</button>
      <div class="line line-grey my-6"></div>
    </section>

    <footer class="modal-footer">
      <p>Occasionally employers roles expire and we don't know about it. We know how frustrating this is... Please help the community and report to us so we can expire this job.</p>

      <button v-if="!reportedExpiredJob" class="btn btn-rounded btn-flex btn-grey" @click="doReport">
        <block-spinner :active="isLoading" size="5" color="text-grey-dark" class="absolute"></block-spinner>
        <span :class="[{'opacity-0':isLoading}]">Report expired listing</span>
      </button>
      <p v-else class="expired-listing-reported mt-9"><strong>Thank you</strong> - a member of the Escape team will investigate.</p>
    </footer>

  </div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'ApplingForJob',

    mixins: [AuthMixins],

    props: {
    	payload: {
    		type: [Object,String]
    	}
    },

    data() {
      return {
        job: false,
        isDisabled: false,
        isLoading: false,
        reportedExpiredJob: false
      }
    },

    mounted() {
      console.log('ApplingForJob Payload:', this.payload);
      this.job = typeof this.payload == 'string' ? JSON.parse(this.payload) : this.payload;
      this.isDisabled = this.job['expired'];
    },

    methods: {
      close() {
        this.$emit('close')
      },
      doApply() {
        if (!this.isDisabled) {
          window.open(this.job['redirect_url'], '_blank');
        }
        this.closeCard(this.job['job_id']);
      },
      doReport() {
        this.isLoading = true;
        let payload = { job_id: this.job['job_id'] };

        // Temp
        setTimeout(() => {
          this.isLoading - false;
          this.reportedExpiredJob = true;
        }, 800);

        return this.$api.reportExpiredJob(payload).then(
	        (response) => {
	        	if (response.data.status == 'success') {

	        	}
	        }
	      ).catch((response) => {
	        console.log("Could not modify alert notifications.", response);
	      });
      },
      closeCard(job_alert_id) {
        this.close();
        if (this.job['closeCard']) {
  				this.emitter.emit('close:saved-jobs', job_alert_id);
        }
			}
    },

    computed: {
      title() {
        return this.isDisabled ? 'Currently Unavailable' : '';
      }
    }
  };
</script>
